import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CERTS } from "@/i18n/translations";
import { Reveal, KineticLines } from "@/components/motion/Reveal";
import SmartImg from "@/components/SmartImg";

export default function Certifications() {
  const { t, loc } = useLang();
  return (
    <div data-testid="certifications-page">
      <section className="pt-36 md:pt-48 pb-16 max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-6 text-claris-green">
          <ShieldCheck size={18} />
          <span className="text-[11px] uppercase tracking-[0.3em] font-semibold">{t("home.trustTitle")}</span>
        </div>
        <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] text-ink">
          <KineticLines lines={[t("nav.certs")]} />
        </h1>
        <p className="mt-8 max-w-2xl text-inkmute text-lg leading-relaxed">
          {loc({ id: "Setiap produk kami diproduksi sesuai standar mutu dan keamanan pangan yang diakui secara nasional dan internasional.", en: "Every product we make is manufactured to nationally and internationally recognised quality and food-safety standards." })}
        </p>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line border border-line">
          {CERTS.map((c, i) => (
            <Reveal key={c.abbr} delay={i * 0.08} className={CERTS.length % 2 === 1 && i === CERTS.length - 1 ? "md:col-span-2" : ""}>
              <div className="bg-white p-10 md:p-14 h-full" data-testid={`certdetail-${c.abbr.toLowerCase()}`}>
                {c.logo ? (
                  <SmartImg src={c.logo} alt={c.name} className="h-24 md:h-28 w-auto object-contain" />
                ) : (
                  <div className="font-serif text-6xl md:text-7xl text-claris">{c.abbr}</div>
                )}
                <h2 className="font-serif text-3xl text-ink mt-6">{c.name}</h2>
                <p className="text-inkmute mt-4 leading-relaxed text-lg">{loc(c.desc)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 pb-28">
        <Reveal className="bg-clara-bg text-clara-text p-12 md:p-20 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div>
            <h2 className="font-serif text-4xl md:text-6xl leading-tight">{loc({ id: "Butuh dokumen sertifikasi?", en: "Need certification documents?" })}</h2>
            <p className="text-clara-text/60 mt-4 max-w-lg leading-relaxed">{loc({ id: "Importir dan mitra B2B dapat meminta salinan sertifikat dan TDS langsung dari tim kami.", en: "Importers and B2B partners can request certificate copies and TDS directly from our team." })}</p>
          </div>
          <Link to="/contact" data-testid="cert-cta-btn" className="group inline-flex items-center gap-2 bg-clara text-white rounded-none px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-[#8A362B] transition-colors shrink-0">
            {t("nav.contact")} <ArrowUpRight size={18} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
